import React, { useEffect, useState } from "react"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { IPageResponse } from "../../../types/IPageResponse"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import InfiniteScroll from "react-infinite-scroll-component"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { InnPopUpListItem } from "./InnPopUpListItem"
import { IInnSuggestion } from "../../../types/inn/IInnSuggestion"

export const InnPopUpList: React.FC<{ visible: boolean; setVisible: (visible: boolean) => void }> = ({
  visible,
  setVisible
}) => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()
  const [innList, setInnList] = useState<IPageResponse<IInnRegistryDto>>()
  const [inn, setInn] = useState<IInnRegistryDto>()
  const [showAddPanel, setShowAddPanel] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [page, setPage] = useState(0)

  useEffect(() => {
    if (page === 0) {
      fetchInnList()
    }
  }, [page])

  useEffect(() => {
    if (!inn?.inn) {
      setInn({ ...inn, name: "" })
      return
    }
    if (inn.inn.length !== 10 && inn.inn.length !== 12) return
    TrinityAPI.suggestInn(inn.inn, response => {
      if (response.status === 200) {
        const rsp: IInnSuggestion = response.data
        if (rsp.suggestions.length > 0)
          setInn({ ...inn, name: rsp.suggestions[0].value, address: rsp.suggestions[0].data.address.value })
        else setInn({ ...inn, name: "", address: "" })
      }
    })
  }, [inn?.inn])

  const fetchInnList = () => {
    TrinityAPI.getInnList(page, searchQuery, response => {
      if (response.status === 200) {
        const currentItems = page === 0 ? new Array<IInnRegistryDto>() : innList?.items || new Array<IInnRegistryDto>()
        setPage(page + 1)
        setInnList({
          ...innList,
          items: currentItems.concat(response.data.items),
          totalPages: response.data.totalPages
        })
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки реестра: " + response.data.message })
      }
    })
  }

  const submit = (forceInn?: IInnRegistryDto) => {
    const currentInn = forceInn || inn
    if (!currentInn) return
    TrinityAPI.createInnRegistryItem(currentInn, response => {
      if (response.status === 200) {
        setInn(undefined)
        setShowAddPanel(false)
        let currentItems = innList?.items || new Array<IInnRegistryDto>()

        if (currentItems.filter(i => i.inn === currentInn.inn).length > 0) {
          const newItems = innList?.items.map(i => {
            if (i.inn === currentInn.inn) {
              i.status = currentInn.status
              i.comment = currentInn.comment
            }
            return i
          })
          setInnList({ ...innList, items: newItems || [], totalPages: innList?.totalPages || 0 })
        } else {
          currentItems.unshift(currentInn)
          setInnList({ ...innList, items: currentItems, totalPages: innList?.totalPages || 0 })
        }
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const remove = (currentInn: string) => {
    if (!currentInn) return
    TrinityAPI.deleteInnRegistryItem(currentInn, response => {
      if (response.status === 200) {
        let newItems = innList?.items.filter(i => i.inn !== currentInn) || new Array<IInnRegistryDto>()
        setInnList({ ...innList, items: newItems, totalPages: innList?.totalPages || 0 })
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const approve = (currentInn: IInnRegistryDto) => {
    let newInn: IInnRegistryDto = {
      inn: currentInn.inn,
      name: currentInn.name,
      address: currentInn.address,
      status: "APPROVED",
      comment: ""
    }
    submit(newInn)
  }

  const lockUnlock = (currentInn: IInnRegistryDto) => {
    if (currentInn.status === "BLOCKED") {
      let newInn: IInnRegistryDto = {
        inn: currentInn.inn,
        name: currentInn.name,
        address: currentInn.address,
        status: "APPROVED",
        comment: ""
      }
      submit(newInn)
    } else {
      setInn({
        ...inn,
        name: currentInn.name,
        address: currentInn.address,
        status: "BLOCKED",
        inn: currentInn.inn,
        comment: currentInn.comment
      })
      setShowAddPanel(true)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setPage(0)
    }
  }

  if (visible) {
    return (
      <section className="user-search-popup">
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={errors} />
        <div className="container-user-search">
          <button className="close-btn-card" onClick={() => setVisible(false)} />
          <div className="header-user-search-popup">
            <h3 className="heading-chapter">Реестр рублевых плательщиков</h3>
            <div className="flex-row-24">
              <input
                type="search"
                className="input-form-search"
                placeholder="Введите название компании, ИНН или комментарий"
                onKeyDown={handleKeyDown}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <button className="btn" onClick={() => setShowAddPanel(true)}>
                Заблокировать
              </button>
            </div>
            {showAddPanel ? (
              <div className="add-new-form">
                <h3 className="heading-chapter">Заблокировать нежелательный ИНН</h3>
                <div className="flex-row-24 flex-wrap-mobile">
                  <input
                    type="text"
                    className="input-form"
                    onChange={e => setInn({ ...inn, inn: e.target.value, status: "BLOCKED" })}
                    value={inn?.inn}
                    placeholder="ИНН"
                  />
                  <input
                    type="text"
                    className="input-form"
                    placeholder="Название компании"
                    value={inn?.name}
                    onChange={e => setInn({ ...inn, name: e.target.value, status: "BLOCKED" })}
                  />
                  <input
                    type="text"
                    name=""
                    id=""
                    className="input-form"
                    onChange={e => setInn({ ...inn, comment: e.target.value, status: "BLOCKED" })}
                    value={inn?.comment}
                    placeholder="Причина"
                  />
                </div>
                <div className="flex-row-24">
                  <input type="submit" value="Заблокировать" className="btn" onClick={() => submit(undefined)} />
                  <button className="btn grey-btn" id="admin12_1212" onClick={() => setShowAddPanel(false)}>
                    Отменить
                  </button>
                </div>
              </div>
            ) : null}
          </div>
          <div className="inn_wrapper">
            <div className="inn_header_list">
              <p className="four-card-text">ИНН</p>
              <p className="four-card-text">Название компании</p>
              <p className="four-card-text">Адрес</p>
              <p className="four-card-text width-200">ФИО</p>
              <p className="four-card-text width-200">Почта</p>
              <p className="four-card-text">Статус</p>
            </div>
            <ul className="block-list-users">
              <InfiniteScroll
                next={fetchInnList}
                hasMore={page < (innList?.totalPages || 0)}
                loader={<>Загрузка...</>}
                dataLength={innList?.items.length || 0}
                style={{ listStyleType: "none" }}
              >
                {innList?.items.map((i, index) => (
                  <InnPopUpListItem inn={i} remove={remove} lockUnlock={lockUnlock} approve={approve} />
                ))}
              </InfiniteScroll>
            </ul>
          </div>
        </div>
      </section>
    )
  } else {
    return null
  }
}
